var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import { SteemEngineConfigUtils } from '@popup/steem/utils/steemengine-config.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
export const setHEActiveRpc = (rpc) => {
    SteemEngineConfigUtils.setActiveApi(rpc);
    return {
        type: SteemActionType.HE_SET_ACTIVE_RPC,
        payload: { rpc: rpc },
    };
};
export const setHEActiveAccountHistoryApi = (api) => {
    SteemEngineConfigUtils.setActiveAccountHistoryApi(api);
    return {
        type: SteemActionType.HE_SET_ACTIVE_ACCOUNT_HISTORY_API,
        payload: { accountHistoryApi: api },
    };
};
export const initHiveEngineConfigFromStorage = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const config = (yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_ACTIVE_CONFIG));
    if (config) {
        SteemEngineConfigUtils.setActiveAccountHistoryApi(config.accountHistoryApi);
        SteemEngineConfigUtils.setActiveApi(config.rpc);
        dispatch({
            type: SteemActionType.HE_LOAD_CONFIG,
            payload: config,
        });
    }
});
